module.exports = __webpack_public_path__ + "img/source03_b1.3a63c460.png";